// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf, arrayOf, recordOf } from "@altostra/type-validations";
import { string, number, nullValidation, boolean } from "@altostra/type-validations/lib/primitives";

const isEngagementCampaignClickDailyStat = objectOf({
  tracking_id: string,
  key: string,
  total: number,
  group: string,
  group_index: number,
  rate_denominator: anyOf(string, nullValidation),
  is_choice: boolean,
  choice_info: anyOf(string, nullValidation),
  choice_text: anyOf(string, nullValidation),
});

export const isEngagementCampaignBannerClickDailyStatsCampaignIdResult = recordOf(
  recordOf(arrayOf(isEngagementCampaignClickDailyStat))
);
